import { Panel } from "primereact/panel";
import { DadosDinamicos } from "./DadosDinamicos";

export default function BeneficioSocial({ beneficioSocial }: { beneficioSocial: any }) {
  if (!beneficioSocial) return null;

  return (
    <div>
      <Panel header="Benefícios Sociais">
        {beneficioSocial.erro ? (
          <p>{beneficioSocial.erro}</p>
        ) : (
          <DadosDinamicos dados={beneficioSocial} />
        )}
      </Panel>
    </div>
  );
}
